export const GROUPTYPE = {
  FOLDERS: "Folders",
  SERIES: "Series",
};
